import React, {Component} from 'react'
import parse from "html-react-parser"
import ContactForm from "./contact-form"
import Link from "../utils/link";
import {ArrowThickRight} from "./icons";
import Fade from "react-reveal/Fade";

const Contact = ({subtitle, title, content, phone, email, button}) => {

  return (
    <section className='contact'>
      <Fade bottom distance='40px'>
        <div className='contact__inner'>
          <div className='contact__content'>
            {subtitle && <span className='contact__subtitle'>{parse(subtitle)}</span>}
            {title && <h2>{parse(title)}</h2>}
            {content && <div>{parse(content)}</div>}
            {phone?.url && <Link className='contact__link' to={`tel:${phone?.url}`}>{phone.title}</Link>}
            {email?.url && <Link className='contact__link' to={`mailto:${email?.url}`}>{email.title}</Link>}
            {button?.url &&
              <Link to={button.url} className='btn btn--circle'>
                {button.title} <span className='btn--mauve'><ArrowThickRight/></span>
              </Link>
            }
          </div>
          <div className='contact__form'>
            <ContactForm/>
          </div>
        </div>
      </Fade>
    </section>
  )
}

export default Contact